
<template>
  <div>
    <QuickReservationForm :external-hide-search-input="externalHideSearchInput"></QuickReservationForm>
  </div>
</template>
<script >

import {defineComponent} from "vue";
import QuickReservationForm from "@/views/templates/QuickReservationForm.vue";

export default defineComponent({
  components: {QuickReservationForm},
  props: ['externalHideSearchInput']
})
</script>

<style scoped>

</style>